/**
 * Day names in the hike trails panel sit next to a numbered badge, so a name
 * that opens with its own "Day 3:" / "Stage 3 –" spends a third of a 300px
 * row repeating the badge and pushes the actual place names into the
 * ellipsis ("Day 1: Marlay Park to K…").
 *
 * Words cover the web app's locales (en, de, es, fr, ga, it, nl, pt). A
 * separator is required so "Day 1 loop" style names are left alone, and a
 * "." followed by a digit is not one ("Day 1.5km…").
 */
const DAY_PREFIX =
  /^\s*(?:day|stage|leg|section|tag|etappe|d[ií]a|etapa|jour|[ée]tape|l[áa]|giorno|tappa|dag)\s*0*(\d+)\s*(?:[:|,\-–—]|\.(?!\d))\s*(\S.*)$/iu;

/**
 * The name to show beside the day badge: the stored name minus a leading
 * "Day N:" prefix, but only when N is the badge's own number — a prefix that
 * disagrees with the badge (renumbered days) still carries information and
 * stays. Names with nothing after the prefix are returned unchanged.
 */
export function dayNameWithoutBadgePrefix(name: string | null | undefined, dayNumber: number): string {
  const trimmed = (name || '').trim();
  const match = trimmed.match(DAY_PREFIX);
  if (!match || Number(match[1]) !== dayNumber) return trimmed;
  return match[2].trim();
}
